import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "sunIcon", "moonIcon", "sidebarSunIcon", "sidebarMoonIcon" ]

  connect() {
    console.log("Theme controller connected!");
    if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      document.documentElement.classList.add('dark');
      this.showSunIcon();
    } else {
      document.documentElement.classList.remove('dark');
      this.showMoonIcon();
    }
    console.log("Initial theme setup complete. Dark mode:", document.documentElement.classList.contains('dark'));
  }

  toggle() {
    console.log("Toggle button clicked!");
    // if set via local storage previously
    if (localStorage.getItem('color-theme')) {
      if (localStorage.getItem('color-theme') === 'light') {
        document.documentElement.classList.add('dark');
        localStorage.setItem('color-theme', 'dark');
        this.showSunIcon();
        console.log("Switched to dark mode");
      } else {
        document.documentElement.classList.remove('dark');
        localStorage.setItem('color-theme', 'light');
        this.showMoonIcon();
        console.log("Switched to light mode");
      }

    // if NOT set via local storage previously
    } else {
      if (document.documentElement.classList.contains('dark')) {
        document.documentElement.classList.remove('dark');
        localStorage.setItem('color-theme', 'light');
        this.showMoonIcon();
        console.log("Switched to light mode (first time)");
      } else {
        document.documentElement.classList.add('dark');
        localStorage.setItem('color-theme', 'dark');
        this.showSunIcon();
        console.log("Switched to dark mode (first time)");
      }
    }
    console.log("Current HTML classes:", document.documentElement.className);
    console.log("Dark mode active:", document.documentElement.classList.contains('dark'));
  }

  showSunIcon() {
    console.log("showSunIcon called");
    // Hide moon icons and show sun icons for all button instances
    if (this.hasMoonIconTarget) {
      this.moonIconTarget.classList.add('hidden');
      console.log("Main moon icon hidden");
    }
    if (this.hasSunIconTarget) {
      this.sunIconTarget.classList.remove('hidden');
      console.log("Main sun icon shown");
    }
    if (this.hasSidebarMoonIconTarget) {
      this.sidebarMoonIconTarget.classList.add('hidden');
      console.log("Sidebar moon icon hidden");
    }
    if (this.hasSidebarSunIconTarget) {
      this.sidebarSunIconTarget.classList.remove('hidden');
      console.log("Sidebar sun icon shown");
    }
  }

  showMoonIcon() {
    console.log("showMoonIcon called");
    // Hide sun icons and show moon icons for all button instances
    if (this.hasSunIconTarget) {
      this.sunIconTarget.classList.add('hidden');
      console.log("Main sun icon hidden");
    }
    if (this.hasMoonIconTarget) {
      this.moonIconTarget.classList.remove('hidden');
      console.log("Main moon icon shown");
    }
    if (this.hasSidebarSunIconTarget) {
      this.sidebarSunIconTarget.classList.add('hidden');
      console.log("Sidebar sun icon hidden");
    }
    if (this.hasSidebarMoonIconTarget) {
      this.sidebarMoonIconTarget.classList.remove('hidden');
      console.log("Sidebar moon icon shown");
    }
  }
}
